<template>
    <div class="search">
        <form class="d-flex align-items-center custom-container" level="search" @submit.prevent="formsubmit">
          <div class="flex-container">
            <div class="search-container">
              <o-select v-if="searchOptions" v-model="selected" :options="searchOptions" autocomplete="'off'" class="form-select-search me-2">
                <template v-slot:selectedOption>
                  search by
                </template>
              </o-select>
              <o-select v-if="sortOptions" v-model="selected" :options="sortOptions" autocomplete="'off'" class="form-select-search me-2">
                <template v-slot:selectedOption>
                  sort by
                </template>
              </o-select>
              
              <div class="search-options">
                <div v-if="selected === 'tenant'" class="d-flex d-inline-block">
                  <o-select v-model="criteria" :options="tenantOptions" autocomplete="'off'" class="form-select-search me-2">
                    <template v-slot:selectedOption>
                      Select tenant
                    </template>
                  </o-select>
                </div>
                <div v-else-if="selected === 'type'" class="d-flex d-inline-block">
                  <o-select v-model="criteria" :options="typeOptions" autocomplete="'off'" class="form-select-search me-2">
                    <template v-slot:selectedOption>
                      Select type
                    </template>
                  </o-select>
                </div>
                <div v-else-if="selected === 'method'" class="d-flex d-inline-block">
                  <o-select v-model="criteria" :options="methodOptions" autocomplete="'off'" class="form-select-search me-2">
                    <template v-slot:selectedOption>
                      Select method
                    </template>
                  </o-select>
                </div>
                <div v-else-if="selected === 'created_at' || selected === 'expired_at' || selected === 'claimed_at'" class="d-flex form-group me-3 date-input-group parent-container">
                  <o-input-text name="date_start" placeholder="start date" type="text" onfocus="(this.type='date')" v-model="date_start" class="ms-2 spacing-input tab-spacing"></o-input-text>
                  <o-input-text name="date_end" placeholder="end date" onfocus="(this.type='date')" type="text" v-model="date_end" class="spacing-input tab-spacing"></o-input-text>
                </div>
                <div v-else-if="selected == 'levels'" class="d-flex d-inline-block">
                  <o-select v-model="level" :options="levelOptions" autocomplete="'off'" class="form-select-search me-2">
                    <template v-slot:selectedOption>
                      select level
                    </template>
                  </o-select>
                </div>
                <div v-else-if="selected == 'status'" class="d-flex d-inline-block">
                  <o-select v-model="status" :options="statusOptions" autocomplete="'off'" class="form-select-search me-2">
                    <template v-slot:selectedOption>
                      select status
                    </template>
                  </o-select>
                </div>
                
                <div v-else-if="selected == 'member_register_tracker'" class="d-flex d-inline-block" style="min-width:220px;">
                  <o-select
                    v-model="campaign_id"
                    :options="campaignOptions"
                    autocomplete="'off'"
                    class="form-select-search me-2"
                  >
                    <template v-slot:selectedOption>
                      select campaign
                    </template>
                  </o-select>
                </div>
                <div v-else class="d-flex d-inline-flex form-group adjust-display child-container">
                  <div v-if="searchBar && selected !== ''">
                    <o-input-text class="criteria" name="search" placeholder="search" type="search" v-model="criteria"></o-input-text>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center button-group" v-if="selected !== ''">
              <div v-if="date_start == '' && date_end == '' && (selected == 'created_at' || selected == 'expired_at' || selected == 'claimed_at')">
                <o-button class="search me-2" type="submit" :variant="'info'" :white="'white'" :size="'sm'" disabled="disabled">Search</o-button>
              </div>
              <div v-else>
                <o-button v-if="searchBar" class="search me-2" type="submit" :variant="'info'" :white="'white'" :size="'sm'">Search</o-button>
              </div>
              <o-button v-if="searchBar" class="search" type="button" :variant="'danger'" :white="'white'" :size="'sm'" @click="clear">Clear</o-button>
            </div>
          </div>
        </form>
    </div>
</template>

<script>
  import { OButton, OInputText, OSelect } from "@/components/OmnihControl";
  export default {
    props: {
      searchOptions: {
        type: Object,
      },
      sortOptions: {
        type: Object,
      },
      levelOptions: {
        type: Object,
      },
      inputValue: {
        type: String,
      },
      submit: {
        type: Function,
      },
      statusOptions: {
        type: Object,
      },
      searchBar: {
        type: Boolean,
        default: true,
      },
      typeOptions: {
        type: Object,
      },
      methodOptions: {
        type: Object,
      },
      tenantOptions: {
        type: Array,
      },
      campaignOptions: {
        type: Array,
        default: () => []
      }
    },
    data: () => {
      return {
        selected: "",
        criteria: "",
        date_start: "",
        date_end: "",
        level: "",
        status: "",
        campaign_id: ''
      };
    },
    watch: {
      selected(newValue) {
        this.$emit('selectedChanged', newValue);
      },
      campaign_id(newValue) {
        this.$emit('campaignChanged', newValue);
      }
    },
    components: {
      OButton,
      OInputText,
      OSelect,
    },
    methods: {
      formsubmit: function () {
        const searchBy = {
          selected: this.selected,
          criteria: this.criteria,
          date_start: this.date_start,
          date_end: this.date_end,
          level: this.level,
          status: this.status,
          campaign_id: this.selected === 'member_register_tracker' ? this.campaign_id : ''
        };
        this.$emit("submit", searchBy);
      },
      clear: function () {
        this.selected = "";
        this.criteria = "";
        this.date_start = "";
        this.date_end = "";
        this.level = "";
        this.status = "";
        this.campaign_id = "";
        this.$emit("clear");
      },
    },
  };
</script>

<style>
.search .btn {
  font-size: 13px;
  padding: 0.8rem;
  font-weight: bold;
}
.search .form-group {
  width: 100%;
  text-align: left;
}
.search input.form-control {
  padding: 0.7rem 1rem 0.7rem 1rem;
  font-size: 14px;
}

.form-control {
  font-size: 20px;
}

.form-select-search .form-select {
  width: auto;
}

.spacing-input {
  margin-right: 20px; 
}

.date-input-group {
  margin-right: 20px; 
}

.button-group {
  margin-left: 50px; 
}

.tab-spacing {
  margin-top: 20px; 
}
</style>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.search-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.search-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.button-group {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

@media (max-width: 768px) {
  .flex-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-options {
    width: 100%;
    margin-top: 10px;
  }

  .button-group {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>